var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('the-header',{attrs:{"title":_vm.t('Login as')}}),_vm._v(" "),_c('nav-body',{attrs:{"links":_vm.nav}},[_c('div',[_vm._v("Temporarily disabled")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f07e178","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/private/admin/loginAs/LoginAs.vue
// module id = null
// module chunks = 